













































  import {DeliveryMethod} from "@/classes/DeliveryMethod";
  import Vue from 'vue';
  import i18n from '@/plugins/i18n';
  import ValidationMixin from '@/mixins/validationMixin';

  export default Vue.extend({
    mixins: [ValidationMixin],
    props: {
      value: {
        type: Object as () => DeliveryMethod,
      },
      deliveryMethods: {
        type: Array as () => Array<DeliveryMethod>
      },
      loading: Boolean,
    },
    computed: {
      deliveryMethod: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('update:value', newValue)
        }
      }
    },
    methods: {
      changed() {
        this.$emit('change')
      },
      translateDeliveryMethodName(deliveryMethod: DeliveryMethod): string {
        return i18n.translateEntityName(deliveryMethod);
      },
      translateDeliveryMethodDescription(deliveryMethod: DeliveryMethod): string {
        return i18n.translateEntityDescription(deliveryMethod);
      },
    },
  })
  ;
